import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import './annualScan.css';
import Footer from '../../components/common/Footer';
import HeaderLp from '../lp-1/HeaderLp';
import { fetchPrebookingPaymentStatus, PrebookingPayload } from '../../api/gsPrebookings';

const AnnualScanPaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const uuid = searchParams.get('uuid');
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<PrebookingPayload | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!uuid) {
        setError('Missing prebooking reference.');
        setLoading(false);
        return;
      }

      const { ok, body } = await fetchPrebookingPaymentStatus({ uuid, sessionId });
      if (cancelled) return;

      if (ok && body?.success && body.data) {
        setData(body.data);
      } else {
        setError(body?.error || 'Unable to confirm payment status.');
      }
      setLoading(false);
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [uuid, sessionId]);

  const aftercareName = data?.aftercare_first_name || 'your aftercare manager';
  const title =
    data?.paid && !sessionId
      ? 'Deposit is already paid'
      : data?.paid
        ? 'Thank you — deposit received'
        : 'Payment received — confirming…';

  return (
    <main>
      <HeaderLp />
      {loading && (
        <div className="annual-scan-state">
          <p>Confirming payment…</p>
        </div>
      )}

      {!loading && error && (
        <div className="annual-scan-state">
          <h1>We could not confirm your payment</h1>
          <p>{error}</p>
          <p>
            If you were charged, contact <a href="mailto:care@getscanned.me">care@getscanned.me</a>.
          </p>
        </div>
      )}

      {!loading && !error && data && (
        <div className="annual-scan-state">
          <h1>{title}</h1>
          <p>
            {data.first_name ? `Hi ${data.first_name}. ` : ''}
            {data.paid
              ? `${aftercareName} will be in touch shortly to arrange your repeat scan.`
              : 'Your deposit is being confirmed.'}
          </p>
          {data.plan_reference && <p>Booking reference: {data.plan_reference}</p>}
          <Link to="/" className="btnPrimary">
            Go to Homepage
          </Link>
        </div>
      )}

      <Footer />
    </main>
  );
};

export default AnnualScanPaymentSuccess;
